<template>
  <div class="responsible">
    <div class="trigger-info">
      <label><strong>Indicador: </strong>{{ trigger.indicatorName }}</label>
      <label><strong>Gatilho: </strong>{{ trigger.triggercode }}</label>
    </div>
    <b-overlay id="overlay-background" class="overlay-config responsible-table" :show="loading" rounded="sm" >
      Responsáveis: {{ responsibles.length }}
      <b-table  hover  responsive  striped  small  :items="responsibles"  :fields="fields"  sort-by="id" >
        <template v-slot:cell(workshifta)="row">
          <b-form-checkbox v-model="row.item.workshifta" @change="(event) => checkAndSetResponsible(event, row.item, 'a')" value:true></b-form-checkbox>
        </template>
        <template v-slot:cell(workshiftb)="row">
          <b-form-checkbox v-model="row.item.workshiftb" @change="(event) => checkAndSetResponsible(event, row.item, 'b')" value:true></b-form-checkbox>
        </template>
        <template v-slot:cell(workshiftc)="row">
          <b-form-checkbox v-model="row.item.workshiftc" @change="(event) => checkAndSetResponsible(event, row.item, 'c')" value:true></b-form-checkbox>
        </template>
        <template v-slot:cell(alwayssend)="row">
          <b-form-checkbox v-model="row.item.alwayssend" @change="(event) => checkAndSetResponsible(event, row.item, 'all')" value:true></b-form-checkbox>
        </template>
      </b-table>
    </b-overlay>
    <div class="groupBtn">
      <img
        src="@/assets/atualizar.png"
        style="margin-left: 30px;"
        title="Recarregar dados"
        alt="Recarregar dados"
        @click="refreshData"
      />
      <img
        v-if="!loading"
        src="@/assets/salvar.png"
        style="margin-left: 20px"
        :title="$t('salvar')"
        alt="Salvar"
        @click="save"
      />
      <img
        id="closeModalPassword"
        src="@/assets/sair.png"
        style="margin-left: 20px"
        :title="$t('sair')"
        alt="Sair"
        @click="$bvModal.hide('setResponsible')"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { urlMainAPI, defaultSuccess } from '../../../global';
import TriggerResponsible from "../tools/triggerResponsible"

  export default {
    name:"TriggerResponsible",
    props:[
      "trigger"
    ],
    data() {
      return {
        fields: TriggerResponsible.fields,
        responsibles: [],
        loading: false,
        wsResposible: { a:false, b:false, c:false, all:false },
        bkp: {}
      }
    },

    watch: {

    },

    methods: {
      async save(){
        this.loading = true
        let url = `${urlMainAPI}/saveresponsiblefortrigger/`
        let responsible = this.responsibles.map(r => ({...r, responssible: r.workshifta || r.workshiftb || r.workshiftc || r.alwayssend}))
        await axios.post(url, responsible).then(res=> {
          defaultSuccess(res.data)
          this.bkp = JSON.stringify(responsible)
        }).catch(console.warn)
        this.loading = false
      },

      async loadResponsibles(){
        let url = `${urlMainAPI}/getresponsiblefortrigger/${this.trigger.id}`
        await axios.get(url).then(res=> {
          this.responsibles = res.data.map(r => ({
            ...r,
            triggerId: this.trigger.id,
            indicatorName: this.trigger.indicatorName,
            triggercode: this.trigger.triggercode
          }))
          this.bkp = JSON.stringify(this.responsibles)
          this.updateWsResposible()
        }).catch(console.warn)
      },

      refreshData(){
        this.responsibles = JSON.parse(this.bkp)
        defaultSuccess(this.$t('configuracoes-desfeitas'))
      },

      checkAndSetResponsible(event, responsibleTarget, workshift){
        if(workshift != 'all')
          responsibleTarget[`workshift${workshift}`] = event;
        else{
          this.setAllWorkshiftFalse()
          this.setAllAlwayssendFalse()
          responsibleTarget.alwayssend = event;
          return
        }
        this.setAllAlwayssendFalse()

        for(let i in this.responsibles ){
          let resp = this.responsibles[i]
          this.checkResponsibleAndSet(workshift, resp, responsibleTarget)
        }
      },

      checkResponsibleAndSet(wsSource, respSource, respTarget){
        if(respSource[`workshift${wsSource}`]){
          if(this.wsResposible[wsSource] && respTarget[`workshift${wsSource}`]){
            respSource[`workshift${wsSource}`] = false
            respTarget[`workshift${wsSource}`] = true
          }
          this.wsResposible[wsSource] = true
        }
      },

      setAllWorkshiftFalse(){
        for(let i in this.responsibles ){
          let resp = this.responsibles[i]
          resp.workshifta = false
          resp.workshiftb = false
          resp.workshiftc = false
        }
      },

      setAllAlwayssendFalse(){
        for(let i in this.responsibles ){
          let resp = this.responsibles[i]
          resp.alwayssend = false
        }
      },

      updateWsResposible(){
        this.wsResposible = { a:false, b:false, c:false, all:false }
        for(let i in this.responsibles ){
          let resp = this.responsibles[i]

          if(resp.workshifta)
            this.wsResposible.a = true
          if(resp.workshiftb)
            this.wsResposible.b = true
          if(resp.workshiftc)
            this.wsResposible.c = true
          if(resp.alwayssend)
          this.wsResposible.all = true
        }
      }
    },

    async mounted() {
      this.loading = true
      await this.loadResponsibles()
      this.loading = false
    },
  }
</script>

<style scoped>

.responsible{
  display: grid;
  grid-template-rows: 10% 80% 10%;
  height: 500px;
  overflow-y: auto;
}

.trigger-info{
  display: flex;
  justify-content: space-around;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
  width: 100%;
}

img {
  cursor: pointer;
  max-height: 35px;
}

.responsible-table{
  padding: 16px;
  margin: 8px;
  border-radius: 4px;
  border: 2px solid #ccc;
  overflow-y: auto;
}

</style>